import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useGetOrderMediaConfig } from "../views/PlaceOrderTest/queryHooks";

type Props = {
  modalHeader: string;
  inputPlaceHolder?: string;
  isOpen: boolean;
  onSave: (
    input: string,
    secondaryInput?: string,
    thirdInput?: string,
    fourthInput?: string,
    fifthInput?: string
  ) => void;
  onClose: () => void;
  cancelBtnText?: string;
  submitBtnText?: string;
  showActionText?: boolean;
  hideInput?: boolean;

  modalSecondaryHeader?: string;
  displaySecondaryInput?: boolean;
  secondaryInput?: string;
  secondaryInputPlaceHolder?: string;

  modalThirdHeader?: string;
  displayThirdInput?: boolean;
  thirdInput?: string;
  thirdInputPlaceHolder?: string;

  modalFourthHeader?: string;
  displayFourthInput?: boolean;
  fourthInput?: string;
  fourthInputPlaceHolder?: string;

  modalFifthHeader?: string;
  displayFifthInput?: boolean;
  fifthInput?: string;
  fifthInputPlaceHolder?: string;
};

const TextInputModal = (props: Props) => {
  const [text, setText] = useState("");
  const [secondaryText, setSecondaryText] = useState("");
  const [thirdText, setThirdText] = useState("");
  const [fourthText, setFourthText] = useState("");
  const [fifthText, setFifthText] = useState("");

  const { data: configData } = useGetOrderMediaConfig();
  const minCharLength = Number(configData?.min_reason_length ?? 0);

  useEffect(() => {
    if (props.isOpen) {
      setText("");
      setSecondaryText(props.secondaryInput || "");
      setThirdText(props.thirdInput || "");
      setFourthText(props.fourthInput || "");
      setFifthText(props.fifthInput || "");
    }
  }, [
    props.isOpen,
    props.secondaryInput,
    props.thirdInput,
    props.fourthInput,
    props.fifthInput,
  ]);

  const handleSave = () => {
    props.onSave(
      text.trim(),
      secondaryText.trim(),
      thirdText.trim(),
      fourthText.trim(),
      fifthText.trim()
    );
    props.onClose();
    resetInputs();
  };

  const handleCloseButtonClick = () => {
    props.onClose();
  };

  const resetInputs = () => {
    setText("");
    setSecondaryText("");
    setThirdText("");
    setFourthText("");
    setFifthText("");
  };

  return (
    <Modal
      returnFocusOnClose={false}
      closeOnOverlayClick={false}
      isOpen={props.isOpen}
      onClose={handleCloseButtonClick}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader paddingBottom={1}>
          {props.modalHeader}
          {props.showActionText && (
            <Text fontStyle="italic" fontSize="xs">
              This Action will be Recorded.
            </Text>
          )}
        </ModalHeader>
        <ModalCloseButton />

        {!props.hideInput && (
          <ModalBody paddingTop={0}>
            <Textarea
              placeholder={props.inputPlaceHolder}
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </ModalBody>
        )}

        {props.modalSecondaryHeader && (
          <ModalHeader paddingBottom={1}>
            {props.modalSecondaryHeader}
          </ModalHeader>
        )}
        {props.displaySecondaryInput && (
          <ModalBody paddingTop={0}>
            <Textarea
              value={secondaryText}
              placeholder={props.secondaryInputPlaceHolder}
              onChange={(e) => setSecondaryText(e.target.value)}
            />
          </ModalBody>
        )}

        {props.modalThirdHeader && (
          <ModalHeader paddingBottom={1}>
            {props.modalThirdHeader}
          </ModalHeader>
        )}
        {props.displayThirdInput && (
          <ModalBody paddingTop={0}>
            <Textarea
              value={thirdText}
              placeholder={props.thirdInputPlaceHolder}
              onChange={(e) => setThirdText(e.target.value)}
            />
          </ModalBody>
        )}

        {props.modalFourthHeader && (
          <ModalHeader paddingBottom={1}>
            {props.modalFourthHeader}
          </ModalHeader>
        )}
        {props.displayFourthInput && (
          <ModalBody paddingTop={0}>
            <Textarea
              value={fourthText}
              placeholder={props.fourthInputPlaceHolder}
              onChange={(e) => setFourthText(e.target.value)}
            />
          </ModalBody>
        )}

        {props.modalFifthHeader && (
          <ModalHeader paddingBottom={1}>
            {props.modalFifthHeader}
          </ModalHeader>
        )}
        {props.displayFifthInput && (
          <ModalBody paddingTop={0}>
            <Textarea
              value={fifthText}
              placeholder={props.fifthInputPlaceHolder}
              onChange={(e) => setFifthText(e.target.value)}
            />
          </ModalBody>
        )}

        <ModalFooter>
          <Button onClick={handleCloseButtonClick} mr={3}>
            {props.cancelBtnText || "Cancel"}
          </Button>
          <Button
            isDisabled={
              text.trim().length < minCharLength &&
              secondaryText === (props.secondaryInput ?? "") &&
              thirdText === (props.thirdInput ?? "") &&
              fourthText === (props.fourthInput ?? "") &&
              fifthText === (props.fifthInput ?? "")
            }
            colorScheme="blue"
            onClick={handleSave}
          >
            {props.submitBtnText || "Confirm"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TextInputModal;
